import React from 'react';
import { Modal } from 'antd';
import { AuditList } from './AuditList';
import styles from './AuditModal.module.less';

export type AuditDetails = {
  title: string;
  columnName: string;
  scriptErrorConfigId: string | null;
};

type AuditModalProps = {
  auditDetails: AuditDetails;
  onClose: () => void;
};

export const AuditModal: React.FC<AuditModalProps> = ({ auditDetails, onClose }) => {
  return (
    <Modal onCancel={onClose} visible={!!auditDetails} className={styles.container} destroyOnClose={true} footer={null}>
      <h2>{auditDetails?.title}</h2>
      <AuditList columnName={auditDetails.columnName} scriptErrorConfigId={auditDetails.scriptErrorConfigId} />
    </Modal>
  );
};
